module.exports = __webpack_public_path__ + "img/paycard.57fe742c.svg";